

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_LEAVE_TYPES_REQUEST = "FETCH_LEAVE_TYPES_REQUEST";
export const FETCH_LEAVE_TYPES_SUCCESS = "FETCH_LEAVE_TYPES_SUCCESS";
export const FETCH_LEAVE_TYPES_FAILURE = "FETCH_LEAVE_TYPES_FAILURE";

export const CREATE_LEAVE_TYPE_REQUEST = "CREATE_LEAVE_TYPE_REQUEST";
export const CREATE_LEAVE_TYPE_SUCCESS = "CREATE_LEAVE_TYPE_SUCCESS";
export const CREATE_LEAVE_TYPE_FAILURE = "CREATE_LEAVE_TYPE_FAILURE";

export const UPDATE_LEAVE_TYPE_REQUEST = "UPDATE_LEAVE_TYPE_REQUEST";
export const UPDATE_LEAVE_TYPE_SUCCESS = "UPDATE_LEAVE_TYPE_SUCCESS";
export const UPDATE_LEAVE_TYPE_FAILURE = "UPDATE_LEAVE_TYPE_FAILURE";

export const DELETE_LEAVE_TYPE_REQUEST = "DELETE_LEAVE_TYPE_REQUEST";
export const DELETE_LEAVE_TYPE_SUCCESS = "DELETE_LEAVE_TYPE_SUCCESS";
export const DELETE_LEAVE_TYPE_FAILURE = "DELETE_LEAVE_TYPE_FAILURE";

// -------------------- FETCH --------------------
export const fetchLeaveTypesRequest = () => ({ type: FETCH_LEAVE_TYPES_REQUEST });
export const fetchLeaveTypesSuccess = (data) => ({ type: FETCH_LEAVE_TYPES_SUCCESS, payload: data });
export const fetchLeaveTypesFailure = (error) => ({ type: FETCH_LEAVE_TYPES_FAILURE, payload: error });

export const fetchLeaveTypes = () => async (dispatch) => {
  dispatch(fetchLeaveTypesRequest());
  const token = localStorage.getItem("token");

  try {
    const res = await axios.get(`${BASE_URL}/v1/api/get_leave_typesAdmin`, {
      headers: { authorization: token },
    });
    dispatch(fetchLeaveTypesSuccess(res.data.data));
  } catch (err) {
    const errorMsg = err?.response?.data?.meta?.message || err.message;
    dispatch(fetchLeaveTypesFailure(errorMsg));
  }
};

// -------------------- CREATE --------------------
export const createLeaveTypeRequest = () => ({ type: CREATE_LEAVE_TYPE_REQUEST });
export const createLeaveTypeSuccess = (data) => ({ type: CREATE_LEAVE_TYPE_SUCCESS, payload: data });
export const createLeaveTypeFailure = (error) => ({ type: CREATE_LEAVE_TYPE_FAILURE, payload: error });

export const createLeaveType = (leaveData) => async (dispatch) => {
  dispatch(createLeaveTypeRequest());
  const token = localStorage.getItem("token");

  try {
    const res = await axios.post(
      `${BASE_URL}/v1/api/create_leave_type`,
      {
        name: String(leaveData.name || "").trim(),
        description: String(leaveData.description || "").trim(),
        total_leaves: parseInt(leaveData.total_leaves) || 0,
      },
      { headers: { "Content-Type": "application/json", authorization: token } }
    );

    dispatch(createLeaveTypeSuccess(res.data));
  } catch (err) {
    const errorMsg = err?.response?.data?.meta?.message || err.message;
    dispatch(createLeaveTypeFailure(errorMsg));
  }
};

// -------------------- UPDATE --------------------
export const updateLeaveTypeRequest = () => ({ type: UPDATE_LEAVE_TYPE_REQUEST });
export const updateLeaveTypeSuccess = (data) => ({ type: UPDATE_LEAVE_TYPE_SUCCESS, payload: data });
export const updateLeaveTypeFailure = (error) => ({ type: UPDATE_LEAVE_TYPE_FAILURE, payload: error });

export const updateLeaveType = (id, leaveData) => async (dispatch) => {
  dispatch(updateLeaveTypeRequest());
  const token = localStorage.getItem("token");

  try {
    const res = await axios.put(
      `${BASE_URL}/v1/api/update_leave_typeAdmin/${id}`,
      {
        name: String(leaveData.name || "").trim(),
        description: String(leaveData.description || "").trim(),
        total_leaves: parseInt(leaveData.total_leaves) || 0,
      },
      { headers: { "Content-Type": "application/json", authorization: token } }
    );

    // Pass the updated data along with the response
    dispatch(updateLeaveTypeSuccess({ data: res.data.data, updated: leaveData }));
  } catch (err) {
    const errorMsg = err?.response?.data?.meta?.message || err.message;
    dispatch(updateLeaveTypeFailure(errorMsg));
  }
};


// -------------------- DELETE --------------------
export const deleteLeaveTypeRequest = () => ({ type: DELETE_LEAVE_TYPE_REQUEST });
export const deleteLeaveTypeSuccess = (id) => ({ type: DELETE_LEAVE_TYPE_SUCCESS, payload: id });
export const deleteLeaveTypeFailure = (error) => ({ type: DELETE_LEAVE_TYPE_FAILURE, payload: error });

export const deleteLeaveType = (id) => async (dispatch) => {
  dispatch(deleteLeaveTypeRequest());
  const token = localStorage.getItem("token");

  try {
    await axios.delete(`${BASE_URL}/v1/api/delete_leave_typeAdmin/${id}`, {
      headers: { authorization: token },
    });

    dispatch(deleteLeaveTypeSuccess(id));
  } catch (err) {
    const errorMsg = err?.response?.data?.meta?.message || err.message;
    dispatch(deleteLeaveTypeFailure(errorMsg));
  }
};
